const HTML_TAG_PATTERN = /(<([^>]+)>)/gi;

export const hasVisibleText = (html: string | undefined | null): boolean =>
  !!html && html.replace(HTML_TAG_PATTERN, "").trim().length > 0;
